import script from "./study-system-old.vue?vue&type=script&setup=true&lang=js"
export * from "./study-system-old.vue?vue&type=script&setup=true&lang=js"

import "./study-system-old.vue?vue&type=style&index=0&id=517989bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517989bb"]])

export default __exports__